const COLUMNS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "快速浏览",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "大瓜精选", href: "#big" },
      { label: "分类速览", href: "#feed" },
      { label: "深度专题", href: "#topic" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { label: "吃瓜指南", href: "#about" },
      { label: "栏目理念", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "返回顶部", href: "#top" },
    ],
  },
  {
    title: "参与互动",
    links: [
      { label: "我要爆料", href: "#contact" },
      { label: "投稿线索", href: "#contact" },
      { label: "商务合作", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-cream-200 bg-cream-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-coral-500 text-lg text-white">
                <i className="ri-fire-line" aria-hidden="true"></i>
              </span>
              <span className="text-xl font-black tracking-tight text-stone-900">
                吃瓜<span className="text-coral-500">在线</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-600">
              吃瓜在线是一个今日热点新鲜事聚合站，实时汇总今日大瓜与今日热议，用看得全、跟得快、说得清的方式，陪伴你把今天的瓜一次吃明白。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-stone-500">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-timer-line text-coral-500" aria-hidden="true"></i>24小时滚动更新
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-shield-check-line text-leaf-600" aria-hidden="true"></i>注重事实与克制
              </span>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-sm font-bold text-stone-900">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-stone-600 transition hover:text-coral-600">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-cream-200 pt-6 sm:flex-row">
          <p className="text-center text-xs text-stone-400 sm:text-left">
            © 2026 吃瓜在线 · 让今天的热点更清晰。本站内容整理自公开讨论，仅供信息参考。
          </p>
          <p className="flex items-center gap-1.5 text-xs text-stone-400 whitespace-nowrap">
            <i className="ri-heart-line text-coral-400" aria-hidden="true"></i>
            理性吃瓜 · 快乐追热点
          </p>
        </div>
      </div>
    </footer>
  );
}